// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__sFzOR","info":"PatientInfo_info__15zA9"};